import { render } from "./Companies-page.vue?vue&type=template&id=510e1f3a&scoped=true"
import script from "./Companies-page.vue?vue&type=script&lang=js"
export * from "./Companies-page.vue?vue&type=script&lang=js"

import "./Companies-page.vue?vue&type=style&index=0&id=510e1f3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510e1f3a"]])

export default __exports__